import { useMemo } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

const useSearchParams = () => {
  const { search } = useLocation()
  const params = useMemo(() => new URLSearchParams(search), [search])
  const history = useHistory()

  const updateQueryParam = (key: string, value: string) => {
    params.set(key, value)
    const newSearch = params.toString()
    history.push({
      search: newSearch,
    })
  }

  return { params, updateQueryParam }
}

export default useSearchParams
